import ms from 'ms';
import Cookies from 'universal-cookie';

import { type CachedRecentSearch, isValidRecentSearch } from '@/redux/api/saveSearch';

const COOKIE_NAME = 'laRecentSearches';
const MAX_ITEMS = 10;
const cookie = new Cookies();

const getCookieOptions = () => ({
    domain: '.liveauctioneers.com',
    expires: new Date(Date.now() + ms('30d')),
    path: '/',
    sameSite: 'none' as const,
    secure: true,
});

export const getRecentSearchesFromCookie = (): CachedRecentSearch[] => {
    try {
        const value = cookie.get<unknown>(COOKIE_NAME);
        return Array.isArray(value) ? value.filter(isValidRecentSearch) : [];
    } catch {
        return [];
    }
};

export const saveRecentSearchToCookie = (item: CachedRecentSearch): void => {
    const existing = getRecentSearchesFromCookie().filter((search) => search.hash !== item.hash);
    cookie.set(COOKIE_NAME, [item, ...existing].slice(0, MAX_ITEMS), getCookieOptions());
};

export const deleteRecentSearchFromCookie = (hash: string): void => {
    const updated = getRecentSearchesFromCookie().filter((search) => search.hash !== hash);
    cookie.set(COOKIE_NAME, updated, getCookieOptions());
};
